import classNames from 'classnames';

import { useCollectionSurtitle } from '../../hooks/useSurtitle';

import HeaderAd from '../ads/HeaderAd';
import CollectionSerieHeader from '../headers/CollectionSerieHeader';
import InfiniteItemsBlocks from '../lists/InfiniteItemsBlocks';

import styles from '../../styles/collections/default-collection.module.css';

interface DefaultCollectionProps {
    // Ad space at the top of the page (`HeaderAd`), on the background of the page
    withHeaderAd?: boolean;
    slug: string;
    id?: string | null;
    type?: string | null;
    surtitle?: string | null;
    title?: string | null;
    description?: string | null;
    header?: CollectionHeader | null;
    metadata?: CollectionMetadata | null;
    image?: Image | null;
    seasons?: CollectionSnippet[] | null;
    children?: CollectionSnippet[] | null;
    current?: boolean;
    className?: string;
}

function DefaultCollection({
    withHeaderAd = false,
    id: collectionId = null,
    slug = null,
    type = null,
    surtitle = null,
    title = null,
    description = null,
    header = null,
    images,
    metadata,
    image,
    current,
    className,
}: DefaultCollectionProps) {
    const { brands, sponsors } = metadata || {};

    const finalSurtitle = useCollectionSurtitle({ type, surtitle, metadata });

    return (
        <div className={classNames([styles.container, className])}>
            {withHeaderAd ? <HeaderAd /> : null}
            <CollectionSerieHeader
                type={type}
                title={title}
                surtitle={finalSurtitle}
                description={description}
                brands={brands}
                sponsors={sponsors}
                metadata={metadata}
                background={
                    type === 'magazine'
                        ? {
                              color: '#fff',
                          }
                        : null
                }
                {...header}
                image={header !== null ? header.image || image : image}
                placeholder={collectionId === null}
                className={styles.header}
                imageClassName={styles.headerImage}
            />
            <main className={styles.content}>
                <InfiniteItemsBlocks
                    query={{
                        collection: collectionId,
                        with_unindexed: true,
                    }}
                    itemsBlocks={[
                        {
                            type: 'items',
                            itemsType: 'documents',
                            presentation: 'grid',
                            cardWidth: 220,
                            cardTheme: 'rounded',
                            cardRatio: 'horizontal',
                            cardSize: 'responsive',
                            // An ad after every 8 items: 2 rows of 4 on desktop
                            count: 8,
                            // Keep 4 columns when the last block has fewer items
                            multiplier: 8,
                            minColumns: 2,
                        },
                    ]}
                    disabled={collectionId === null}
                    className={styles.blocks}
                    cardTheme="rounded"
                    cardWithout={['serie', 'collection', 'time']}
                />
            </main>
        </div>
    );
}

export default DefaultCollection;
